<template>
  <div class="d-flex gap-2 justify-end">
    <v-btn v-if="archiveButtonIsShown"
      color="primary"
      depressed
      small
      @click="isArchiveDialogOpen = true"
      :disabled="!isArchiveActive"
    >
      <span>{{ $t('livechat.chats.closeAndArchiveChatButton') }}</span>
      <!-- <v-icon>mdi-archive-outline</v-icon> -->
    </v-btn>

    <v-btn v-if="closeButtonIsShown" color="primary" depressed small @click="isDialogOpen = true">
      {{ $t('livechat.chats.closeChatButton') }}
    </v-btn>

    <HubDialog
      v-model="isDialogOpen"
      :title="$t('livechat.chats.closeChatDialogTitle')"
      :confirmText="$t('livechat.chats.closeChatDialogConfirm')"
      @onPrimary="closeChat()"
      @onSecondary="isDialogOpen = false"
    >
      <p>{{ $t('livechat.chats.closeChatDialogBody') }}</p>
    </HubDialog>

    <HubDialog
      v-model="isArchiveDialogOpen"
      :title="$t('livechat.chats.closeChatDialogTitle')"
      @onPrimary="closeChatAndArchive()"
      @onSecondary="isArchiveDialogOpen = false"
    >
      <p>{{ $t('livechat.chats.closeAndArchiveChatBody') }}</p>
    </HubDialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import HubDialog from '@/components/hub/HubDialog.vue';

// Original in src/views/SettingsArchive.vue
const viewCloseButtonsEnums = {
  archiveClose: 'archive&close',
  close: 'close',
  closeAndArchiveClose: 'close_archive&close',
};

export default {
  name: 'LivechatCloseChat',
  components: {
    HubDialog,
  },
  props: {
    chat: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isArchiveParamsConfigured: false,
      isArchiveQuotaEnabled: false,
      isArchiveActive: true,
      isArchiveDialogOpen: false,
      isDialogOpen: false,

      archiveButtonIsShown: false,
      closeButtonIsShown: true,
    };
  },
  computed: {
    ...mapGetters('bots', ['currentBotId', 'getBotSettings']),
    ...mapGetters('livechat', ['inSupervisorMode']),
  },
  methods: {
    async closeChatAndArchive() {
      if (!this.isArchiveQuotaEnabled || !this.isArchiveActive || !this.isArchiveParamsConfigured) {
        console.error('Archive quota is not enabled or archive logic is not active');
        return;
      }

      const result = await this.$store.dispatch('livechat/sendEmailArchive', {
        uniqueBotId: this.chat.uniqueBotId,
        uniqueUserId: this.chat.uniqueUserId,
      });

      const { success, error } = result || {};
      if (error) {
        console.error('Error while sending email archive. Error:', error);
        return;
      }

      if (success) await this.closeChat();
    },
    async closeChat() {
      if (this.inSupervisorMode) {
        await this.$store.dispatch('livechat/closeChatSupervisor', this.chat);
      } else {
        await this.$store.dispatch('livechat/closeChat', this.chat);
      }
    },
    async init() {
      const { archive, quota, notifications } = await this.getBotSettings(this.currentBotId) || {};
      const { templateId, receipients } = notifications?.mail?.archive ?? {};

      this.isArchiveParamsConfigured = templateId && receipients?.length;
      this.isArchiveQuotaEnabled = quota?.archive ?? false;
      this.isArchiveActive = archive?.active ?? false;

      const viewCloseButtons = archive?.viewCloseButtons ?? viewCloseButtonsEnums.closeAndArchiveClose;
      this.archiveButtonIsShown = this.isArchiveQuotaEnabled && this.isArchiveActive && this.isArchiveParamsConfigured
        && [viewCloseButtonsEnums.archiveClose, viewCloseButtonsEnums.closeAndArchiveClose].includes(viewCloseButtons);

      /* !this.archiveButtonIsShown - because at Least one button should be shown!
         !this.isArchiveActive - because if archive is not active, the archive button should not be shown */
      this.closeButtonIsShown = [viewCloseButtonsEnums.close, viewCloseButtonsEnums.closeAndArchiveClose].includes(viewCloseButtons)
        || !this.archiveButtonIsShown || !this.isArchiveActive;
    },
  },
  created() {
    this.init();
  },
};
</script>
